const exportUsersToExcel = require("./exportService");

const helper = {
  exportDate(data, name) {
    const workSheetColumnName = [
      "SN",
      "LeaveType",
      "EmployeeName",
      "DateRequested",
      "StartDate",
      "EndDate",
      "LeaveDays",
      "ActedBy",
      "ReasonForRejection",
      "Status",
    ];

    const workSheetName = "Records";
    const filePath = `${name}.xlsx`;

    exportUsersToExcel(data, workSheetColumnName, workSheetName, filePath);
  },

  printData(records, name) {
    const datas = [];
    records.map((data, i) => {
      let record = {};

      record["SN"] = i + 1;
      record["LeaveType"] = data.leave_id.type;
      record["EmployeeName"] =
        data.requested_by.first_name + data.requested_by.last_name;
      record["DateRequested"] = data.requested_on;
      record["StartDate"] = data.start_date;
      record["EndDate"] = data.end_date;
      record["LeaveDays"] = data.leave_days;
      record["ActedBy"] = data.approved_by
        ? data.approved_by.first_name + data.requested_by.last_name
        : "";
      record["ReasonForRejection"] = data.reason_for_rejection
        ? data.reason_for_rejection
        : "";
      record["Status"] =
        data.status === 1
          ? "Pending"
          : data.status === 2
          ? "Approved"
          : data.status === 3
          ? "Rejected"
          : "";

      datas.push(record);
    });

    console.log("DATAS", datas);
    // console.log("rec", records);

    this.exportDate(datas, name);
  },
};

module.exports = helper;



// WEBPACK FOOTER //
// ./src/utils/exportToExcel/helper.js